export const LOGIN = "LOGIN"
export const LOADING = "LOADING"
export const INITIAL_STATE = "INITIAL_STATE"
